import { z } from 'zod';
import { ArgoConnectionKindEnum } from '../db';

export const serialConnectionConfigSchema = z.object({
    kind: z.literal(ArgoConnectionKindEnum.Serial),
    details: z.object({
        baud: z.string(),
    }),
});
export type SerialConnectionConfig = z.infer<typeof serialConnectionConfigSchema>;
